module.exports = __webpack_public_path__ + "img/canvasMenu8.dff22816.svg";